import { ITenant, Tenant } from "@sp-crm/core";
import { Action } from "redux";
import { Actions } from "../actions";

export interface TenantState {
    tenant: ITenant;
}

export function tenantReducer(state: TenantState, action: Action): TenantState {
    if (!state || action.type === Actions[Actions.LOGOUT]) {
        state = {
            tenant: null,
        };
    }

    if (
        action.type === Actions[Actions.LOAD_TENANT_FINISH] ||
        action.type === Actions[Actions.UPDATE_TENANT_FINISH]
    ) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
        const loadedTenant = Tenant.fromDocument((action as any).tenant);
        state = {
            ...state,
            tenant: loadedTenant,
        };
    }

    return state;
}
